(function () {
    'use strict';

    angular
        .module('app.application.role')
        .run(appRun);

    appRun.$inject = ['routerHelper'];
    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
             {
                 state: 'application.role',
                 config: {
                     url: '/:ApplicationID/role',
                     params: {
                         ApplicationID: {
                             value: '0'
                         }
                     },
                     templateUrl: 'app/application/role/dashboard/role.dashboard.html',
                     controller: 'RoleDashboardController',
                     controllerAs: 'vm',
                     title: 'Application Role Dashboard',
                     ncyBreadcrumb: {
                         parent: 'application.overview({ApplicationID: vm.ApplicationID})',
                         label: 'Role'
                     },
                     settings: {
                         isVisible: false,
                         nav: 3,
                         content: '<i class="fa fa-dashboard"></i> Role Dashboard'
                     }
                 }
             }
        ];
    }
})();
